import { render, staticRenderFns } from "./Klassen.vue?vue&type=template&id=023864a4&scoped=true&"
import script from "./Klassen.vue?vue&type=script&lang=js&"
export * from "./Klassen.vue?vue&type=script&lang=js&"
import style0 from "./Klassen.vue?vue&type=style&index=0&id=023864a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023864a4",
  null
  
)

export default component.exports